import type { IStorage } from "./storage.constants";
import { STORAGE } from "./storage.constants";
import { postJSON } from "./apiUtils";
import { GetLatestKeywordCampaignsResponse } from "@whatslly/types/integrations/KeywordInsights";
import { KeywordInsightsSettings } from "@whatslly/types/keyword-insights/KeywordInsightsSettings";

export class UpdateKeywordPoliciesService {
  async checkLastUpdate(storage: IStorage, fetchMethod: any, notifyKeywordInsights: () => Promise<void>) {
    const userLastUpdate = await storage.get(STORAGE.USER_LAST_KEYWORD_CAMPAIGNS_UPDATE);
    const { etoken, whatsllyPod } = await storage.get([STORAGE.ETOKEN_KEY, STORAGE.POD_KEY]);
    if (!etoken || etoken === "false") {
      return;
    }
    try {
      const response = await postJSON({
        urlSuffix: "/integrations/keyword-insights/get-latest-campaigns",
        pod: whatsllyPod,
        body: JSON.stringify({
          userLastUpdate,
        }),
        etoken,
        fetchMethod,
      });
      const body: GetLatestKeywordCampaignsResponse = await response.json();
      if (!body.success) return;
      this.updatePolicies(storage, body.keywordInsightsSettings, notifyKeywordInsights);
    } catch {
      return;
    }
  }

  async updatePolicies(storage: IStorage, settings: KeywordInsightsSettings, notifyKeywordInsights: () => Promise<void>) {
    await storage.set(STORAGE.KEYWORD_INSIGHTS_SETTINGS, settings);
    await storage.set(STORAGE.USER_LAST_KEYWORD_CAMPAIGNS_UPDATE, Date.now());
    await notifyKeywordInsights();
  }

  async removeStorageLastKeywordPoliciesUpdate(storage: IStorage) {
    await storage.remove(STORAGE.USER_LAST_KEYWORD_CAMPAIGNS_UPDATE);
  }

  async updateStorageLastKeywordPoliciesUpdate(storage: IStorage) {
    await storage.set(STORAGE.USER_LAST_KEYWORD_CAMPAIGNS_UPDATE, String(Date.now()) as unknown as number);
  }
}
export const updateKeywordPoliciesService = new UpdateKeywordPoliciesService();
